<template>
	<div class="sk-locales">
		<shape :class="['sk-locales__item', {'sk-locales__item--active': isActive('en-gb')}]" src="/static/svg/flags/uk.svg" @click.native="onClick('en-gb')" />
		<shape :class="['sk-locales__item', {'sk-locales__item--active': isActive('fr')}]" src="/static/svg/flags/fr.svg" @click.native="onClick('fr')" />
		<shape :class="['sk-locales__item', {'sk-locales__item--active': isActive('pt')}]" src="/static/svg/flags/pt.svg" @click.native="onClick('pt')" />
	</div>
</template>

<script>
export default {
	methods: {
		isActive(lang) {
			return lang === this.$i18n.locale
		},
		onClick (lang) {
			this.$i18n.locale = lang
		}
	},
}
</script>

<style scoped>
.sk-locales {
	display: flex;
	align-items: center;
	justify-content: center;
}
.sk-locales__item {
	width: 32px;
	height: 32px;
	opacity: 0.25;
	transition: opacity 300ms;
	cursor: pointer;
	margin: 10px 3px;
}

.sk-locales__item:hover,
.sk-locales__item:active,
.sk-locales__item--active {
	opacity: 1;
}

@media screen and (min-width: 481px) and (max-width: 768px) {
	.sk-locales__item {
		display: none;
	}
	.sk-locales__item--active {
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/i18n/LocaleFlagSelector.vue